import { useState } from 'react';
import { btnPrimario, btnSecundario } from '../../components/ui/estilos';
import { Campo, entrada } from '../agenda/campos';
import { Toggle } from '../config/ui';
import { ROLES, ROL_LABEL, usuarioDeAcceso } from './DialogosEquipo';

const PERMISOS: { key: string; label: string; grupo: string }[] = [
  { key: 'puede_abrir_cajon', label: 'Abrir cajón manualmente', grupo: 'Caja' },
  { key: 'puede_abrir_turno', label: 'Abrir turno de caja', grupo: 'Caja' },
  { key: 'puede_cerrar_turno', label: 'Cerrar turno de caja', grupo: 'Caja' },
  { key: 'puede_depositar_retirar', label: 'Depósitos y retiros', grupo: 'Caja' },
  { key: 'puede_cobrar', label: 'Cobrar / registrar pago', grupo: 'Caja' },
  { key: 'puede_cancelar_cuenta', label: 'Cancelar cuentas', grupo: 'Caja' },
  { key: 'puede_modificar_comanda', label: 'Modificar comanda', grupo: 'Operación' },
  { key: 'puede_agregar_personas', label: 'Cambiar personas en mesa', grupo: 'Operación' },
  { key: 'puede_aplicar_promociones', label: 'Aplicar promociones', grupo: 'Operación' },
  { key: 'puede_registrar_mermas', label: 'Registrar mermas', grupo: 'Inventario' },
  { key: 'puede_crear_requisicion', label: 'Crear requisiciones', grupo: 'Inventario' },
  { key: 'puede_autorizar_comida', label: 'Autorizar comida de empleados', grupo: 'Inventario' },
  { key: 'puede_gestionar_objetivos', label: 'Crear/editar objetivos SMART', grupo: 'Administración' },
  { key: 'puede_ver_reportes', label: 'Ver reporte de ventas', grupo: 'Reportes' },
  { key: 'puede_ver_auditoria', label: 'Ver Auditoría', grupo: 'Reportes' },
];
const GRUPOS = [...new Set(PERMISOS.map(p => p.grupo))];
const ESTACIONES = [['ambas', 'Cocina y barra'], ['cocina', 'Solo cocina'], ['barra', 'Solo barra']];
const titulo: React.CSSProperties = { fontSize: 14, fontWeight: 700, color: 'var(--muted)' };

export default function DetalleEmpleado({ u, onCambiar, onClave, onEliminar }: {
  u: any; onCambiar: (datos: any, ok?: string) => void; onClave: () => void; onEliminar: () => void;
}) {
  const [f, setF] = useState({ nombre: u.nombre || '', email: u.email || '' });
  const cambio = f.nombre !== u.nombre || f.email !== u.email;

  const activo = () => {
    // Desactivar deja a alguien fuera de inmediato: se confirma.
    const msg = u.activo ? `${u.nombre} ya no podrá entrar hasta que lo actives de nuevo.` : `${u.nombre} volverá a poder entrar.`;
    if (window.confirm(`¿${u.activo ? 'Desactivar' : 'Activar'} a ${u.nombre}?\n\n${msg}`)) onCambiar({ activo: !u.activo });
  };

  return (
    <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <h2 style={{ margin: 0, fontSize: 22 }}>{u.nombre}</h2>
          <div style={{ fontSize: 14, color: 'var(--muted)' }}>Entra como <b>{usuarioDeAcceso(u.email)}</b></div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 14 }}>
          {u.activo ? 'Activo' : 'Inactivo'}
          <Toggle value={u.activo ? 'true' : 'false'} onChange={activo} />
        </label>
      </div>

      <Campo label="Nombre"><input value={f.nombre} onChange={e => setF(x => ({ ...x, nombre: e.target.value }))} maxLength={100} style={entrada} /></Campo>
      <Campo label="Correo"><input type="email" value={f.email} onChange={e => setF(x => ({ ...x, email: e.target.value }))} style={entrada} /></Campo>
      {cambio && <button onClick={() => f.nombre.trim() && f.email.trim() && onCambiar({ nombre: f.nombre.trim(), email: f.email.trim() }, 'Datos guardados.')} style={{ ...btnPrimario, height: 48, fontSize: 15 }}>Guardar cambios</button>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={titulo}>Rol</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {ROLES.map(r => (
            <button key={r} onClick={() => r !== u.rol && onCambiar({ rol: r, estacion: 'ambas' }, `Ahora es ${ROL_LABEL[r].toLowerCase()}.`)} aria-pressed={u.rol === r}
              style={{ ...btnSecundario, height: 44, fontSize: 15, borderColor: u.rol === r ? 'var(--brand-texto)' : undefined, background: u.rol === r ? 'var(--well)' : undefined }}>{ROL_LABEL[r]}</button>
          ))}
        </div>
        {u.rol === 'cocina' && (
          <select value={u.estacion || 'ambas'} onChange={e => onCambiar({ estacion: e.target.value })} aria-label="Estación en Comandas" style={entrada}>
            {ESTACIONES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        )}
      </div>

      <button onClick={onClave} style={{ ...btnSecundario, fontSize: 15 }}>Cambiar contraseña</button>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={titulo}>Permisos de acceso</div>
        {GRUPOS.map(g => (
          <div key={g} role="group" aria-label={g} style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--muted)', padding: '10px 0 2px' }}>{g.toUpperCase()}</div>
            {PERMISOS.filter(p => p.grupo === g).map(p => (
              <label key={p.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: '8px 0', borderBottom: '1px solid var(--line)', fontSize: 15 }}>
                {p.label}
                <Toggle value={u[p.key] ? 'true' : 'false'} onChange={() => onCambiar({ [p.key]: !u[p.key] })} />
              </label>
            ))}
          </div>
        ))}
      </div>

      <button onClick={onEliminar} style={{ background: 'none', border: 'none', color: 'var(--danger)', fontSize: 15, fontWeight: 700, cursor: 'pointer', height: 44, alignSelf: 'flex-start' }}>Eliminar empleado</button>
    </div>
  );
}
